<template>
    <ValidationProvider
      :vid="vid"
      :name="$attrs.name"
      :rules="rules"
      v-slot="{ valid, errors }"
    >
      <div class="p-field">
        <label v-if="$attrs.label" v-bind="$attrs">{{ $attrs.label }}</label>
        <InputNumber 
          v-model.trim="innerValue"
          v-bind="$attrs"
          :class="{ 'p-invalid': errors[0] && !valid }" 
          :suffix="suffix"
          :minFractionDigits="minFractionDigits"
          :maxFractionDigits="maxFractionDigits"
          mode="decimal"
          autofocus
        />
        <br>
        <small id="inputLiveFeedback" class="p-invalid">
          {{ errors[0] }}
        </small>
      </div>
    </ValidationProvider>
  </template>
  
  <script>
  import { ValidationProvider } from "vee-validate";
  
  export default {
    components: {
      ValidationProvider
    },
    props: {
      vid: {
        type: String
      },
      rules: {
        type: [Object, String],
        default: ""
      },
      suffix: {
        type: String,
        default: ""
      },
      minFractionDigits: {
        type: Number,
        default: null
      },
      maxFractionDigits: {
        type: Number,
        default: null
      },
      // must be included in props
      value: {
        type: null
      }
    },
    data: () => ({
      innerValue: null
    }),
    watch: {
      // Handles internal model changes.
      innerValue(newVal) {
        this.$emit("input", newVal);
      },
      // Handles external model changes.
      value(newVal) {
        this.innerValue = newVal;
      }
    },
    created() {
      if (this.value) {
        this.innerValue = this.value;
      }
    }
  };
  </script>
  


// WEBPACK FOOTER //
// src/components/base/InputNumber.vue